<template>
  <div class="link-views no-bg">
    <div class="flexDivTop">
      <div class="leftSide">
        <Row :gutter="16" class="virtualLab" type="flex">
          <i-col :xs="12" :sm="12" :md="12" :lg="6" :xxl="6">
            <div class="bg-div">
              <div class="img">
                <img src="../../../assets/imgs/item2.png">
              </div>
              <div class="imgInfo">
                <div class="small text-overflow">总访问量（次）</div>
                <div class="big theme">{{PV}}</div>
              </div>
            </div>
          </i-col>
          <i-col :xs="12" :sm="12" :md="12" :lg="6" :xxl="6">
            <div class="bg-div">
              <div class="img">
                <img src="../../../assets/imgs/item5.png">
              </div>
              <div class="imgInfo">
                <div class="small text-overflow">本周访问量（次）</div>
                <div class="big theme">{{Days7}}</div>
              </div>
            </div>
          </i-col>
          <i-col :xs="12" :sm="12" :md="12" :lg="6" :xxl="6">
            <div class="bg-div">
              <div class="img">
                <img src="../../../assets/imgs/item6.png">
              </div>
              <div class="imgInfo">
                <div class="small text-overflow">学生用户量（人）</div>
                <div class="big theme">{{StuTotal}}</div>
              </div>
            </div>
          </i-col>
          <i-col :xs="12" :sm="12" :md="12" :lg="6" :xxl="6">
            <div class="bg-div">
              <div class="img">
                <img src="../../../assets/imgs/item7.png">
              </div>
              <div class="imgInfo">
                <div class="small text-overflow">教师用户量（人）</div>
                <div class="big theme">{{TchTotal}}</div>
              </div>
            </div>
          </i-col>
        </Row>
      </div>
      <div class="rightSide">
        <div class="bg-div">
          <div class="imgInfo">
            <div class="small text-overflow">
              <Icon type="md-contacts" class="error"/>当前在线人数
            </div>
            <div class="big error">{{OnlinePv}}</div>
          </div>
        </div>
      </div>
    </div>
    <Row :gutter="16" type="flex">
      <i-col span="24">
        <div class="result" id="result" ref="result">
          <div class="resultTitle">每日登陆情况</div>
          <div class="resultInfo">
            <ve-line
              :grid="{left:16,right:60}"
              :judge-width="true"
              :data="chartData1"
              :data-empty="dataEmpty1"
              :settings="chartSettings"
              :extend="chartExtend1"
            ></ve-line>
          </div>
        </div>
      </i-col>
    </Row>
  </div>
</template>
<script>
import * as homeApi from "../../../api/home-api.js";
export default {
  name: "adminHome",

  data() {
    this.chartExtend1 = {
      tooltip: {
        show: true,
        formatter: function(params) {
          return (
            params[0].axisValue +
            "<br/>" +
            params[0].seriesName +
            "：" +
            params[0].data[1] +
            "次" +
            "<br/>" +
            params[1].seriesName +
            "：" +
            params[1].data[1] +
            "次"
          );
        },
        confine: true
      },
      xAxis: {
        axisLabel: {
          interval: 0, //0：全部显示，1：间隔为1显示对应类目，2：依次类推，（简单试一下就明白了，这样说是不是有点抽象）
          rotate: -20 //倾斜显示，-：顺时针旋转，+或不写：逆时针旋转
        }
      }
    };
    this.chartSettings = {
      yAxisName: ["次数"],
      labelMap: {
        StuNum: "学生",
        TchNum: "教师"
      }
    };
    return {
      chartData1: {},
      dataEmpty1: true,
      PV: 0, //总浏览量
      Days7: 0, //近七天访问量
      StuTotal: 0, // 学生用户量
      TchTotal: 0, //教师用户量
      OnlinePv: 0 //当前在线人数
    };
  },
  computed: {},
  beforeCreate() {},
  created() {},
  watch: {},
  mounted() {
    this.getInfoData();
  },
  methods: {
    // 首页
    getInfoData() {
      homeApi.GetStatistics().then(res => {
        var ScoreList = res.LoginNum;
        if (res.LoginNum.length > 0) {
          this.chartData1 = {
            columns: ["Data", "StuNum", "TchNum"],
            rows: res.LoginNum
          };
          this.dataEmpty1 = false;
        } else {
          this.chartData1 = {};
          this.dataEmpty1 = true;
        }
        this.isRize = 2;
        this.PV = res.PV;
        this.Days7 = res.Days7;
        this.StuTotal = res.StuTotal;
        this.TchTotal = res.TchTotal;
        this.OnlinePv = res.OnlinePv;
      });
    }
  }
};
</script>
<style scoped>
</style>